import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-background" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-border bg-card p-8 md:p-10">
        <div className="mb-8 text-center">
          <span className="font-serif text-3xl">Gulhar</span>
          <p className="text-[10px] tracking-[0.35em] uppercase text-primary mt-1">Admin Portal</p>
        </div>
        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <div className="space-y-2">
            <Label className="text-xs tracking-wide uppercase text-muted-foreground">Email</Label>
            <Input required type="email" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-background border-border h-12" placeholder="admin@gulhar.com" />
          </div>
          <div className="space-y-2">
            <Label className="text-xs tracking-wide uppercase text-muted-foreground">Password</Label>
            <Input required type="password" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-background border-border h-12" placeholder="••••••••" />
          </div>
          {error && <p className="text-destructive text-sm" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full h-12 bg-primary text-primary-foreground hover:opacity-90 rounded-none tracking-wide">
            {loading ? "Signing in…" : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
